module.exports = __webpack_public_path__ + "img/create-account.aebc106e.svg";